import React from 'react';
import { connect } from 'react-redux';
import Transition from 'react-transition-group/Transition';
import { DynamicLoading } from './LoadingStyles';
import Icon from '../../assets/icons/efrs_loading.svg';

const Loading = ({ loading }) => {
  return (
    <Transition
      timeout={{ enter: 0, exit: 200 }}
      in={loading}
      unmountOnExit
      mountOnEnter
    >
      {state => (
        <DynamicLoading state={state}>
          <img src={Icon} alt="Loading" />
        </DynamicLoading>
      )}
    </Transition>
  );
};

const mapStateToProps = (state, ownProps) => ({
  loading: state.loading
});

export default connect(mapStateToProps)(Loading);



// WEBPACK FOOTER //
// ./src/components/Loading/LoadingComponent.js